// extracted by mini-css-extract-plugin
export default {"page":"Maintenance_page__8KCaj","overflow":"Maintenance_overflow__fMGGf","hoverAnimation":"Maintenance_hoverAnimation__T7bPq"};